import type { ResearchDisclaimerKind } from "../constants/researchDisclaimers";

const STORAGE_KEY = "tessera.researchDisclaimer.v1";

type ExpandState = Partial<Record<ResearchDisclaimerKind, boolean>>;

function canUseLocalStorage(): boolean {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

function readAll(): ExpandState {
  if (!canUseLocalStorage()) return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as ExpandState;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

/** Default expanded when the user has never toggled this notice. */
export function readResearchDisclaimerExpanded(kind: ResearchDisclaimerKind): boolean {
  const all = readAll();
  if (typeof all[kind] === "boolean") return all[kind]!;
  return true;
}

export function writeResearchDisclaimerExpanded(
  kind: ResearchDisclaimerKind,
  expanded: boolean
): void {
  if (!canUseLocalStorage()) return;
  try {
    const next: ExpandState = { ...readAll(), [kind]: expanded };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Quota / private mode — ignore.
  }
}
